import React, {  useEffect, useState } from "react";
import { useMyContext } from "../../../../../screens/GSTModule/GstrForms/GstrThreeB/ContextApi";
import GstrThreeBInvoiceTable from "../GstrThreeBInvoiceTable";
import { getGstrThreeBDataTemplate } from "../../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import { GstrThreeBDataType } from "../../../../../commonTypes/gstTypes";
type AppProps = {
  tableHeaderData: TableHeadersType[];
  gstrThreeBData: GstrThreeBDataType | {};
  singleHeader: string;
};
const Gstr3BFourTableData = ({
  tableHeaderData,
  singleHeader,
  gstrThreeBData,
}: AppProps) => {
  const { handleGstrThreeBInvoiceListData, gstrThreeBInvoiceData } =
    useMyContext();
  const [showViewSource, setViewSource] = useState(false);
  const [showViewSourceIndex, setViewSourceIndex] = useState("");
  const [newGstrThreeBTableData, setNewGstrThreeBTableData] = useState<any>(
    structuredClone(
      getGstrThreeBDataTemplate(
        gstrThreeBData,
        gstrThreeBInvoiceData,
        singleHeader
      )
    )
  );

  const invoiceObjectKey = (name: string) => {
    if (gstrThreeBInvoiceData?.gstr3b_4) {
      if (name?.includes("Import of goods")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4A"]?.import_of_goods;
      } else if (name?.includes("Import of services")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4A"]?.import_of_services;
      } else if (name?.includes("Inward supplies liable")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4A"]?.liable_to_reverse_charge;
      } else if (name?.includes("Inward supplies from ISD")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4A"]?.isd;
      } else if (name?.includes("all other ITC")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4A"]?.others;
      } else if (
        name?.includes(
          "As per rules 38,42 & 43 of CGST Rules and section 17(5)"
        )
      ) {
        return gstrThreeBInvoiceData?.gstr3b_4["4B"]?.as_per_cgst_rules;
      } else if (name?.includes("(2) Others")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4B"]?.gothers;
      } else if (name?.includes("Net ITC available (A-B)")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4C"];
      } else if (name?.includes("ITC reclaimed which was reversed")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4D"]?.as_per_section_17;
      } else if (name?.includes("Ineligible ITC under section 16(4)")) {
        return gstrThreeBInvoiceData?.gstr3b_4["4D"]?.others;
      }
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (showViewSourceIndex) {
      const temp = structuredClone(newGstrThreeBTableData);
      const updatedData =
        !!temp?.data &&
        temp?.data?.map((data: any, index: number) => {
          if (index === +showViewSourceIndex) {
            temp.data[index].showViewSource = !data.showViewSource;
            temp.data[index].sourceData = gstrThreeBInvoiceData?.gstr3b_4
              ? invoiceObjectKey(data?.natureOfSupplies)
              : [];
          }
          return data;
        });
      const newUpdatedData = {
        data: updatedData,
      };
      setNewGstrThreeBTableData({ ...newUpdatedData });
    }
  }, [showViewSource, gstrThreeBInvoiceData]);

  return (
    <>
      {newGstrThreeBTableData?.data?.map((item: any, index: number) => {
        return (
          <>
            <tr key={item?.natureOfSupplies}>
              {tableHeaderData?.map((header: any) => {
                if (header.value === "description") {
                  return (
                    <td
                      style={{
                        fontWeight:
                          item?.fullLength ||
                          item?.natureOfSupplies ===
                            "C. Net ITC available (A-B)"
                            ? "500"
                            : "",
                        borderRight: item?.fullLength ? "none" : "",
                        width: "48%",
                      }}
                    >
                      <span>{item?.natureOfSupplies}</span>
                      {item?.isSource ? (
                        <span
                          style={{
                            color: "red",
                            marginLeft: "12px",
                            marginTop: "1px",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            !gstrThreeBInvoiceData.hasOwnProperty("gstr3b_4") &&
                              handleGstrThreeBInvoiceListData("4");
                            setViewSource(!showViewSource);
                            setViewSourceIndex(index.toString());
                          }}
                        >
                          View Source
                        </span>
                      ) : null}
                    </td>
                  );
                } else if (
                  header.value === "total_count" &&
                  !item?.fullLength
                ) {
                  return (
                    <td>
                      {item?.tableRowData?.total_count
                        ? item?.tableRowData?.total_count
                        : 0}
                    </td>
                  );
                } else if (
                  header.value === "total_taxable_value" &&
                  !item?.fullLength
                ) {
                  return (
                    <td>
                      {item?.tableRowData?.total_taxable_value
                        ? item?.tableRowData?.total_taxable_value?.toFixed(2)
                        : 0}
                    </td>
                  );
                } else if (
                  header.value === "total_igst_amount" &&
                  !item?.fullLength
                ) {
                  return (
                    <td>
                      {item?.tableRowData?.total_igst_amount
                        ? item?.tableRowData?.total_igst_amount?.toFixed(2)
                        : 0}
                    </td>
                  );
                } else if (
                  header.value === "total_cgst_amount" &&
                  !item?.fullLength
                ) {
                  return (
                    <td>
                      {item?.tableRowData?.total_cgst_amount
                        ? item?.tableRowData?.total_cgst_amount?.toFixed(2)
                        : 0}
                    </td>
                  );
                } else if (
                  header.value === "total_sgst_amount" &&
                  !item?.fullLength
                ) {
                  return (
                    <td>
                      {item?.tableRowData?.total_sgst_amount
                        ? item?.tableRowData?.total_sgst_amount?.toFixed(2)
                        : 0}
                    </td>
                  );
                } else {
                  return !item?.fullLength && <td>0</td>;
                }
              })}
            </tr>
            {item?.showViewSource && (
              <GstrThreeBInvoiceTable
                gstrThreeBInvoiceData={item?.sourceData ? item?.sourceData : []}
              />
            )}
          </>
        );
      })}
    </>
  );
};

export default Gstr3BFourTableData;
